export enum LicenceTypeEnum {
	AMATEUR = 1, PROFESSIONAL,
}
